export const theme = {
  colors: {
    button: {
      primary: {
        base: '#0a363c',  // Dark teal primary
        hover: '#082a30',  // Slightly darker teal
        text: '#ffffff'    // White text
      },
      secondary: {
        base: '#e2bf9c',  // Beige secondary
        hover: '#d4b08c',  // Slightly darker beige
        text: '#0a363c'    // Dark teal text
      }
    },
    background: {
      main: '#ffffff',     // White background
      input: '#f5f5f5',   // Light gray for inputs
      card: '#ffffff'      // White cards
    },
    text: {
      primary: '#0a363c',  // Dark teal primary text
      secondary: '#6d6d6d', // Medium gray secondary text
      placeholder: '#a0a0a0' // Light gray placeholder
    }
  }

}